import React, { useState } from "react";
import { Grid, Switch, IconButton, Button, Chip } from "@material-ui/core";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import withStyles from "@material-ui/styles/withStyles";
import { styles } from "./ScheduleItem.styles";
import Weekdays from "../../../../common/components/displays/Weekdays";
function ScheduleItem({
  classes,
  schedule,
  onActivate,
  loading,
  onEditSchedule,
  onDeleteSchedule,
  onStopInstance,
  instance,
}) {
  const [hover, sethover] = useState(false);
  return (
    <Grid
      container
      direction="row"
      justify="space-between"
      alignItems="center"
      wrap="nowrap"
      spacing={1}
      onMouseOver={() => sethover(true)}
      onMouseOut={() => sethover(false)}
      className={
        classes.scheduleItem +
        " " +
        (!schedule.active ? classes["disabled"] : classes["active"]) +
        " " +
        (instance && classes["inuse"])
      }
    >
      <Grid item>
        <Grid container direction="column" alignItems="flex-start">
          <Grid item>
            <b>{schedule.designation} </b>
          </Grid>
          <Grid item>
            {schedule.boxDesignation + " - " + schedule.sensorDesignation}{" "}
            <Chip className={classes.chip} size="small" color="secondary" label={schedule.sensorCode} />
          </Grid>
          {instance && (
            <Grid item>
              <b>running</b>{" "}
              <Button
                className={classes.smallerBtn}
                variant="contained"
                size="small"
                color="primary"
                onClick={() => onStopInstance(instance)}
              >
                Stop
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item style={{ flexGrow: 1 }}>
        <Grid container direction="column" alignItems="center" spacing={1}>
          <Grid item>
            starts @ {schedule.startTime} ({schedule.duration} mins)
          </Grid>
          <Grid item>
            <Weekdays weekdays={schedule.weekdays} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container direction="column" alignItems="flex-end" spacing={1}>
          <Grid item>
            <div style={{ height: "20px", display: "block" }}>
              <IconButton
                aria-label="edit"
                disableRipple
                size="small"
                onClick={() => onEditSchedule(schedule)}
                className={classes.icon}
                style={hover ? { display: "inline" } : { display: "none" }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
              <IconButton
                aria-label="edit"
                disableRipple
                size="small"
                onClick={() => onDeleteSchedule(schedule)}
                className={classes.icon}
                style={hover ? { display: "inline" } : { display: "none" }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </div>
          </Grid>
          <Grid item>
            <Grid container direction="row" alignItems="center" justify="flex-end">
              <Grid item>
                <Switch
                  checked={schedule.active}
                  color="primary"
                  onClick={(e) => onActivate(schedule.id, e.target.checked)}
                  disabled={Boolean(loading)}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(ScheduleItem);
